export default __webpack_public_path__ + "static/media/elevate-red-2.27f7aae1.png";